import es from "./es";
import en from "./en";
import fr from "./fr";

export default {
  en: en,
  es: es,
  fr: fr,
  default: es,
};
